import { ROUTES } from "const";
import { courseService } from "libs/api";

export class TFAINDIRE {
  static async getDashboardCards(courseCode, registrationCode) {
    const cards = [
      {
        title: "Lezioni telematiche in modalità sincrona",
        link: ROUTES.COURSE_LESSONLIVE_SCHEDULE_ONLINE_ALL,
        img: "/img/icon/presentation.png",
        className: "image-box",
      },
      {
        title: "Laboratori: attività in modalità telematica sincrona",
        link: ROUTES.COURSE_LESSONTRAINING_SCHEDULE + "/laboratorio",
        img: "/img/icon/presentation.png",
        className: "image-box",
      },
    ];

    if (courseCode.endsWith("_48")) {
      cards.push({
        title: "Tirocinio Indiretto",
        link: ROUTES.COURSE_LESSONTRAINING_SCHEDULE + "/tirocinio",
        img: "/img/icon/8.webp",
        className: "image-box",
      });
      cards.push({
        title: "Nuove tecnologie per l'apprendimento - TIC",
        link: ROUTES.COURSE_LESSONTRAINING_SCHEDULE + "/tic",
        img: "/img/icon/8.webp",
        className: "image-box",
      });
      cards.push({
        title: "Tirocinio diretto",
        link: `${ROUTES.COURSE_LESSON_ACTIVITY}/training/TirocinioDirettoIndire/222`, // TODO: load id form db
        img: "/img/icon/8.webp",
        className: "image-box",
      });
    }

    cards.push({
      title: "Materiale esercitazioni",
      link: ROUTES.LEARNING_MAIN,
      img: "/img/icon/lessons.png",
      className: "image-box",
    });

    cards.push({
      title: "Situazione pagamenti",
      link: ROUTES.MU_COURSE_PAYMENTS,
      img: "/img/icon/payment.png",
      className: "image-box",
    });

    cards.push({
      title: "Messaggi",
      link: ROUTES.COURSE_TICKETS,
      img: "/img/icon/message.png",
      className: "image-box",
    });

    try {
      const result = await courseService.perfezionamentoActiveLink(
        registrationCode
      );
      if (result.data.payload) {
        const { payload } = result.data;
        if (payload.writtenReservationEnabled === "1") {
          cards.push({
            title: "Prenotazione Esami",
            link: ROUTES.COURSE_EXAMFINAL_ONSITE_RESERVATION,
            img: "/img/icon/badge.png",
            className: "image-box",
          });
        }

        if (result.data.payload.enableUDA === "1") {
          cards.push({
            title: "Elaborato su un caso studio",
            link: ROUTES.COURSE_TFAINDIRE_EXAMWRITTEN,
            img: "/img/icon/examdone.png",
            className: "image-box",
          });
        }

        if (payload.titleRequestEnabled === "1") {
          cards.push({
            title: 'Certificato Finale',
            link: ROUTES.MU_UM_TITLE_DONWLOAD,
            img: '/img/icon/graduate.png',
            className: 'image-box'
          });
        }
      }
    } catch (error) { }

    return cards;
  }

  static getDashboardNotices(courseCode, registrationCode) {
    let notices = [
      {
        content: `<p>Linee guida per lo svolgimento delle lezioni in modalità telematica sincrona. 
            <a href="https://www.formazionedocenti.it/files/corsi/tfa-indire/linee-guida-lezioni-tfaindire.pdf" target="_blank">Clicca qui per scaricare le linee guida</a></p>`,
      },
      {
        title: `IMMATRICOLAZIONE`,
        content: `<p>Al fine di poter procedere alla formalizzazione dell'immatricolazione la invitiamo, entro e non oltre le ore 15:00 del 22 luglio 2025, ad effettuare il pagamento della prima rata premendo il pulsante "Situazione Pagamenti"</p>
            <p>In caso di mancata immatricolazione nel rispetto dei termini e delle modalità indicate nel presente avviso, verrà considerato a tutti gli effetti rinunciatario e, senza ulteriori avvisi e comunicazioni, si procederà con lo scorrimento della graduatoria.</p>`,
      },
    ];

    if (courseCode.startsWith('SASUMTRIENNALISTI')) {
      notices.push(
        {
          title: `Modalità di svolgimento della prova finale`,
          content: `<p><a href="https://www.formazionedocenti.it/files/corsi/tfa-indire/Prova_finale_INDIRE_UNICAMILLUS_art6.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>`,
        }, {
        title: `Calendario Lezioni telematiche in modalità sincrona (aggiornati al 24/09/25)`,
        content: `<a href="https://www.formazionedocenti.it/files/corsi/tfa-indire/CalendarioINDIRE40.pdf" target="_blank">Clicca qui per scaricare l'informativa</a>`,
      });
    } else if (courseCode.endsWith('_48')) {
      notices.push(
        {
          title: `Modalità di svolgimento della prova finale`,
          content: `<p><a href="https://www.formazionedocenti.it/files/corsi/tfa-indire/Prova_finale_INDIRE_UNICAMILLUS_art7_48.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>`,
        }, {
        title: `Calendario Lezioni telematiche in modalità sincrona (aggiornati al 24/09/25)`,
        content: `<a href="https://www.formazionedocenti.it/files/corsi/tfa-indire/CalendarioINDIREestero48.pdf" target="_blank">Clicca qui per scaricare l'informativa</a>`,
      }, {
        title: `Linee guida per la redazione della Relazione finale di Tirocinio Diretto`,
        content: `<a href="https://www.formazionedocenti.it/files/corsi/tfa-indire/LineeguidaRelazioneTirocinioINDIRE.pdf" target="_blank">Clicca qui per scaricare le linee guida</a>`,
      });
    } else if (courseCode.endsWith('_36')) {
      notices.push(
        {
          title: `Modalità di svolgimento della prova finale`,
          content: `<p><a href="https://www.formazionedocenti.it/files/corsi/tfa-indire/Prova_finale _INDIRE_UNICAMILLUS_art7_36.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></p>`,
        }, {
        title: `Calendario Lezioni telematiche in modalità sincrona (aggiornati al 24/09/25)`,
        content: `<a href="https://www.formazionedocenti.it/files/corsi/tfa-indire/CalendarioINDIREestero36.pdf" target="_blank">Clicca qui per scaricare l'informativa</a>`,
      });
    }

    return notices;
  }
}
